"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[641],{

/***/ 7268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ck": function() { return /* binding */ CardFaq; },
/* harmony export */   "cO": function() { return /* binding */ CardAuctionDetail; },
/* harmony export */   "dg": function() { return /* binding */ CardFacilityDetail; },
/* harmony export */   "fe": function() { return /* binding */ CardAuction; },
/* harmony export */   "ue": function() { return /* binding */ InfoWindowFacility; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8368);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4357);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8377);
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4532);






var CardAuction = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "flex flex-row items-center space-x-2 w-[15.375rem] min-w-fit",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "min-w-[3.375rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    src: "/images/img-example.png",
                    alt: "",
                    className: "w-[3.375rem] object-cover rounded-xl"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col space-y-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-regular-normal font-medium text-neutral-900 break-all line-clamp-1",
                        children: "Central xxxxx xxxx xxxx"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row items-center space-x-1.5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-neutral-900",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .LocationBoldIcon */ .Oi, {
                                    size: "16"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "break-all line-clamp-1 text-tiny-none text-neutral-800",
                                children: "Fresno, xxxxx xxxxx xxxx"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CardAuctionDetail = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/facility/detail/".concat(data.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: "flex flex-row items-center space-x-2 w-[15.375rem] min-w-fit",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "min-w-[4.25rem]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        src: data.image.md,
                        alt: data.name,
                        className: "w-[4.25rem] object-cover rounded-xl"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col space-y-1.5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-regular-normal font-medium text-neutral-900 break-all line-clamp-1",
                            children: data.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "font-bold text-primary-500 text-small-tight",
                            children: [
                                "#",
                                data.id,
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "font-normal text-neutral-600 capitalize",
                                    children: [
                                        data.type ? data.type === "in_person" ? "in person" : data.type : "Caravan",
                                        " ",
                                        "Auction"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row items-center space-x-1.5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-neutral-900",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .LocationBoldIcon */ .Oi, {
                                        size: "16"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "break-all line-clamp-1 text-tiny-none text-neutral-800",
                                    children: data.address
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var InfoWindowFacility = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white rounded-xl p-3 w-[11.75rem] flex flex-col focus:!outline-none focus-visible:!outline-none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: data.image.lg,
                alt: data.name,
                className: "w-full h-[5.25rem] rounded-lg object-cover"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "font-medium text-small-normal text-neutral-900 truncate whitespace-normal line-clamp-2 break-all mt-2",
                children: data.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-1 font-bold text-primary-500 text-tiny-tight",
                children: [
                    "#",
                    data.id
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-1.5 text-neutral-500 text-tiny-tight",
                children: [
                    data.type ? data.type === "in_person" ? "in person" : data.type : "Caravan",
                    " ",
                    "Auction"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-tiny-normal text-neutral-600 line-clamp-2 break-all mt-1",
                children: data.address
            })
        ]
    });
};
var CardFacilityDetail = function(param) {
    var data = param.data, isBlur = param.isBlur;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative flex flex-row items-center justify-between w-full md:w-[33.438rem] min-w-fit bg-white p-3.5 rounded-xl",
        children: [
            isBlur && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-0 bg-white w-full h-full opacity-50"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row items-center space-x-3.5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[5.25rem]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            src: data.image.lg,
                            alt: data.unit_number,
                            className: "w-[5.25rem] object-cover rounded-xl"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col space-y-1.5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-regular-none md:text-title3 font-bold text-neutral-900 break-all line-clamp-1",
                                children: [
                                    "#",
                                    data.unit_number
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "font-medium text-neutral-900 text-small-normal",
                                children: "Start this week"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "break-all line-clamp-1 text-tiny-normal md:text-regular-normal text-neutral-600",
                                children: "1,200 watching this auction"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "border border-neutral-200 rounded-full p-2 text-primary-500 md:hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .SaveAddIcon */ .PF, {
                    size: "16"
                })
            })
        ]
    });
};
var CardFaq = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "mx-auto w-full rounded-[0.875rem] bg-white px-3 py-3.5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Disclosure */ .p, {
                children: function(param) {
                    var open = param.open;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Disclosure.Button */ .p.Button, {
                                className: "flex w-full justify-between space-x-1 text-left text-[1.375rem] leading-6 font-bold text-primary-900 focus:outline-none",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "break-words line-clamp-2",
                                        children: data.attributes.title
                                    }),
                                    open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .CloseCircleIcon */ .uC, {
                                        className: "text-neutral-500 min-w-[1.5rem]"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .AddBoldCircleIcon */ .S4, {
                                        className: "text-primary-500 min-w-[1.5rem]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .u, {
                                enter: "transition ease duration-500 transform",
                                enterFrom: "opacity-0 -translate-y-12",
                                enterTo: "opacity-100 translate-y-0",
                                leave: "transition ease duration-300 transform",
                                leaveFrom: "opacity-100 translate-y-0",
                                leaveTo: "opacity-0 -translate-y-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Disclosure.Panel */ .p.Panel, {
                                    className: "mt-4.5 text-regular-normal text-neutral-600",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "break-words line-clamp-3",
                                            children: data.attributes.short_description
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/faq/".concat(data.attributes.slug),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "font-bold text-primary-500",
                                                children: "Read More..."
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            })
        })
    });
};


/***/ }),

/***/ 3140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D9": function() { return /* binding */ LoadingFaq; },
/* harmony export */   "Qu": function() { return /* binding */ LoadingMap; },
/* harmony export */   "TX": function() { return /* binding */ NotFound; },
/* harmony export */   "YO": function() { return /* binding */ LoadingFacility; },
/* harmony export */   "tf": function() { return /* binding */ LoadingPricingPlan; },
/* harmony export */   "v1": function() { return /* binding */ LoadingBlog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4561);
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4532);



var LoadingPricingPlan = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-8 flex flex-col px-6 py-4.5 rounded-3xl bg-neutral-100 border border-neutral-200 w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "96px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "12",
                        ry: "12",
                        width: "100%",
                        height: 96
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-[2.125rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "52px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "12",
                        ry: "12",
                        width: "100%",
                        height: 52
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-[2.125rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "48px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "40",
                        ry: "40",
                        width: "100%",
                        height: 48
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-[2.125rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "30px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "8",
                        ry: "8",
                        width: "100%",
                        height: 30
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "30px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "8",
                        ry: "8",
                        width: "70%",
                        height: 30
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "30px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "8",
                        ry: "8",
                        width: "50%",
                        height: 30
                    })
                })
            })
        ]
    });
};
var LoadingMap = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full h-full rounded-[0.875rem] bg-neutral-200 flex flex-col justify-between p-4.5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "72px",
                    foregroundColor: "#E2E8F0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "40",
                        ry: "40",
                        width: "100%",
                        height: 72
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "64px",
                    foregroundColor: "#E2E8F0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "12",
                        ry: "12",
                        width: "100%",
                        height: 64
                    })
                })
            })
        ]
    });
};
var LoadingFacility = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                scope: "row",
                className: "p-3 flex flex-row items-center space-x-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[2.5rem]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "40px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "12",
                                ry: "12",
                                width: "100%",
                                height: 40
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col space-y-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                    width: "100%",
                                    height: "16px",
                                    foregroundColor: "#E2E8F0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                        x: "0",
                                        y: "0",
                                        rx: "6",
                                        ry: "6",
                                        width: "100%",
                                        height: 16
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                    width: "100%",
                                    height: "16px",
                                    foregroundColor: "#E2E8F0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                        x: "0",
                                        y: "0",
                                        rx: "6",
                                        ry: "6",
                                        width: "50%",
                                        height: 14
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                className: "p-3 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "100%",
                                height: 16
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "50%",
                                height: 14
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                className: "p-3 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "100%",
                                height: 16
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "50%",
                                height: 14
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                className: "p-3 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "100%",
                                height: 16
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "50%",
                                height: 14
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var LoadingFaq = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-[4.5rem]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            width: "100%",
            height: "72px",
            foregroundColor: "#EDF2F7",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0",
                y: "0",
                rx: "14",
                ry: "14",
                width: "100%",
                height: 72
            })
        })
    });
};
var NotFound = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col justify-center items-center h-full text-center w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                src: "/images/illustration/box.svg",
                alt: "Not Found",
                className: "w-[7.75rem] h-[7.75rem] mt-9"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-7",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        className: "text-neutral-900 text-title3",
                        children: "No Records"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-neutral-600 text-regular-tight mt-4.5",
                        children: [
                            "there’s no any ",
                            props.message || "records",
                            " found"
                        ]
                    })
                ]
            })
        ]
    });
};
var LoadingBlog = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        width: "100%",
                        height: "250px",
                        foregroundColor: "#EDF2F7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "14",
                            ry: "14",
                            width: "100%",
                            height: "250"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-3.5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        width: "100%",
                        height: "20px",
                        foregroundColor: "#EDF2F7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "6",
                            ry: "6",
                            width: "110",
                            height: "20"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-3.5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        width: "100%",
                        height: "34px",
                        foregroundColor: "#EDF2F7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "8",
                            ry: "8",
                            width: "222",
                            height: "34"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        width: "100%",
                        height: "112px",
                        foregroundColor: "#EDF2F7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "8",
                            ry: "8",
                            width: "100%",
                            height: "112"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": function() { return /* binding */ MAP_USA; },
/* harmony export */   "D5": function() { return /* binding */ getSpesificResultGeocode; },
/* harmony export */   "JO": function() { return /* binding */ boundariesUSA; },
/* harmony export */   "JY": function() { return /* binding */ OPTIONS; },
/* harmony export */   "TW": function() { return /* binding */ createRadius; },
/* harmony export */   "V9": function() { return /* binding */ getKeyByValue; },
/* harmony export */   "Vw": function() { return /* binding */ METER; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "gI": function() { return /* binding */ LOADER; },
/* harmony export */   "he": function() { return /* binding */ MAP_DEFAULT; },
/* harmony export */   "lC": function() { return /* binding */ USA_CENTER; },
/* harmony export */   "w6": function() { return /* binding */ getDynamicResult; }
/* harmony export */ });
/* unused harmony exports boundariesUSAOutside, MAP_ID, OPTIONS_OLD, LIBRARIES, getCity, getResultCity, getResultAddress, VERSION */
// NEW YORK DEFAULT
var MAP_DEFAULT = {
    lat: 40.7232274,
    lng: -74.001718
};
// USA CENTER
var USA_CENTER = {
    lat: 39.8097343,
    lng: -98.5556199
};
// USA BORDER LIMITS
var USA_BOUNDS = {
    north: 67.4250519739,
    south: -21.082827843,
    west: -162.1197412536,
    east: -28.3502100036
};
// PLACE ID USA
var MAP_USA = "ChIJCzYy5IS16lQRQrfeQ5K5Oxw";
var boundariesUSA = {
    strokeColor: "#3366FF",
    strokeOpacity: 1,
    strokeWeight: 1,
    fillColor: "#3366FF",
    fillOpacity: 0.4
};
var boundariesUSAOutside = {
    strokeColor: "#1A202C",
    strokeOpacity: 1,
    strokeWeight: 1,
    fillColor: "#1A202C",
    fillOpacity: 0.2
};
// MAP ID
var MAP_ID = [
    "a2af02ba90571cc7"
];
// OPTIONS GOOGLE MAP
var OPTIONS = {
    restriction: {
        latLngBounds: USA_BOUNDS,
        strictBounds: false
    },
    gestureHandling: "cooperative",
    mapId: "a2af02ba90571cc7",
    fullscreenControl: false,
    zoomControl: false,
    streetViewControl: false,
    mapTypeControl: false
};
var OPTIONS_OLD = {
    restriction: {
        latLngBounds: USA_BOUNDS,
        strictBounds: false
    },
    gestureHandling: "cooperative"
};
// CREATE RADIUS FROM WAYPOINTS
var createRadius = function(waypoints) {
    var rad = {};
    waypoints.map(function(e, key) {
        rad[key + 1] = e.toString();
    });
    return rad;
};
// LIBRARIES
var LIBRARIES = [
    "places"
];
// MILES TO METERS
var METER = 1609.344;
var getCity = function(data) {
    var city = "";
    var searching = data.filter(function(e) {
        if (e.types.includes("locality")) {
            return e;
        } else if (e.types.includes("administrative_area_level_1")) {
            return e;
        }
    });
    if (searching.length > 0) {
        city = searching[0].long_name;
    }
    return city;
};
var getResultCity = function(data, type) {
    var city = "";
    var searching = data.filter(function(e) {
        if (e.types.includes(type)) {
            return e;
        } else if (e.types.includes("locality")) {
            return e;
        } else if (e.types.includes("administrative_area_level_1")) {
            return e;
        }
    });
    if (searching.length > 0) {
        var searching2 = searching[0].address_components.filter(function(e) {
            if (e.types.includes("locality")) {
                return e;
            } else if (e.types.includes("administrative_area_level_1")) {
                return e;
            }
        });
        if (searching2.length > 0) {
            city = searching[0].formatted_address;
        }
    }
    return city;
};
var getDynamicResult = function(data, type) {
    var res = "";
    var searching2 = data.address_components.filter(function(e) {
        if (e.types.includes(type)) {
            return e;
        }
    });
    if (searching2.length > 0) {
        res = searching2[0].long_name;
    }
    return res;
};
var getResultAddress = function(data) {
    var address = "";
    if (data.length > 0) {
        address = data[0].formatted_address;
    }
    return address;
};
// VERSION OF MAP
var VERSION = "beta";
var LOADER = {
    googleMapsApiKey: "AIzaSyAocY3PHCXrFWuMvro_jwYfEmc7wb5mJDA",
    libraries: LIBRARIES,
    mapIds: MAP_ID,
    version: VERSION
};
var getKeyByValue = function(object, value) {
    return Object.keys(object).find(function(key) {
        return object[key] === value;
    });
};
var sleep = function(ms) {
    return new Promise(function(r) {
        return setTimeout(r, ms);
    });
};
var getSpesificResultGeocode = function(data) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "locality";
    var result = data.filter(function(e) {
        if (e.types.includes(type)) {
            return e;
        }
    });
    if (result.length > 0) {
        return result[0];
    }
    var result_postal_code = data.filter(function(e) {
        if (e.types.includes("postal_code")) {
            return e;
        }
    });
    if (result_postal_code.length > 0) {
        return result_postal_code[0];
    }
    var result_route = data.filter(function(e) {
        if (e.types.includes("route")) {
            return e;
        }
    });
    if (result_route.length > 0) {
        return result_route[0];
    }
    var result_country = data.filter(function(e) {
        if (e.types.includes("country")) {
            return e;
        }
    });
    if (result_country.length > 0) {
        return result_country[0];
    }
    return data[0];
};


/***/ }),

/***/ 2210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ partials_RegionDetail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./app/component/commons/button/Button.tsx
var Button = __webpack_require__(1201);
// EXTERNAL MODULE: ./app/component/commons/card/Card.tsx
var Card = __webpack_require__(7268);
// EXTERNAL MODULE: ./app/component/commons/icon/SvgIcon.tsx
var SvgIcon = __webpack_require__(8377);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(7054);
// EXTERNAL MODULE: ./app/component/commons/loading/Skeleton.tsx
var Skeleton = __webpack_require__(3140);
// EXTERNAL MODULE: ./app/component/plugins/map/helper.ts
var helper = __webpack_require__(2712);
;// CONCATENATED MODULE: ./app/component/plugins/map/MapRegion.tsx









var MapRegion = function(param) {
    var mode = param.mode, onChange = param.onChange, data = param.data;
    var ref = (0,esm/* useJsApiLoader */.Ji)(helper/* LOADER */.gI), isLoaded = ref.isLoaded, loadError = ref.loadError;
    var ref1 = (0,react.useState)(data.length > 0 ? {
        lat: data[0].lat,
        lng: data[0].lng
    } : helper/* MAP_DEFAULT */.he), defaultCenter = ref1[0], setDefaultCenter = ref1[1];
    var ref2 = (0,react.useState)({
        default: 11,
        min: 4
    }), zoom = ref2[0], setZoom = ref2[1];
    var ref3 = (0,react.useState)(null), selectedElement = ref3[0], setSelectedElement = ref3[1];
    var ref4 = (0,react.useState)(null), map = ref4[0], setMap = ref4[1];
    var onLoad = (0,react.useCallback)(function callback(map) {
        setMap(map);
    }, [
        defaultCenter
    ]);
    (0,react.useEffect)(function() {
        if (map) {
            var bounds = new window.google.maps.LatLngBounds(defaultCenter);
            data.forEach(function(e) {
                bounds.extend({
                    lat: e.lat,
                    lng: e.lng
                });
            });
            map.fitBounds(bounds);
        }
    }, [
        map
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* GoogleMap */.b6, {
                id: "map_sual",
                mapContainerClassName: "w-full h-full rounded-[0.875rem] flex flex-col p-4.5 focus:!outline-none focus-visible:!outline-none",
                center: defaultCenter,
                zoom: zoom.default,
                options: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, helper/* OPTIONS */.JY), {
                    gestureHandling: "none"
                }),
                onLoad: onLoad,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        data.map(function(e, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
                                icon: "/images/map/icon/pin-marker.svg",
                                position: {
                                    lat: e.lat,
                                    lng: e.lng
                                },
                                options: {
                                    map: map
                                },
                                onClick: function() {
                                    setSelectedElement(e);
                                },
                                onMouseOver: function() {
                                    setSelectedElement(e);
                                },
                                onMouseOut: function() {
                                    setSelectedElement(null);
                                }
                            }, key);
                        }),
                        selectedElement ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InfoWindow */.nx, {
                            position: {
                                lat: selectedElement.lat,
                                lng: selectedElement.lng
                            },
                            onCloseClick: function() {
                                setSelectedElement(null);
                            },
                            options: {
                                disableAutoPan: true
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* InfoWindowFacility */.ue, {
                                data: selectedElement
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative mt-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute right-2 bottom-0 flex flex-col space-y-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-auto shadow-lv3 flex flex-col bg-transparent rounded-xl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "p-3 pb-1.5 bg-white rounded-t-xl hover:bg-neutral-200 cursor-pointer transition ease-in-out duration-200",
                                            onClick: function() {
                                                var res = ((map === null || map === void 0 ? void 0 : map.getZoom()) || 0) + 1;
                                                setZoom((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, zoom), {
                                                    default: res
                                                }));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* PlusIcon */.pO, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "p-3 pt-1.5 bg-white rounded-b-xl hover:bg-neutral-200 cursor-pointer transition ease-in-out duration-200",
                                            onClick: function() {
                                                var res = ((map === null || map === void 0 ? void 0 : map.getZoom()) || 0) - 1;
                                                setZoom((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, zoom), {
                                                    default: res
                                                }));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* MinusIcon */.V_, {})
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* LoadingMap */.Qu, {}),
            loadError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-6 text-neutral-900",
                children: "Map cannot be loaded right now, sorry."
            })
        ]
    });
};
/* harmony default export */ var map_MapRegion = (MapRegion);

// EXTERNAL MODULE: ./app/helpers/MenuList.ts
var MenuList = __webpack_require__(2105);
;// CONCATENATED MODULE: ./app/layouts/partials/RegionDetail.tsx








var RegionDetail = function(param) {
    var mode = param.mode, data = param.data, type = param.type;
    var recent = (0,react.useRef)(null);
    var onScroll = function(scrollOffset) {
        if (recent.current) {
            recent.current.scrollLeft += scrollOffset;
        }
    };
    (0,react.useEffect)(function() {
        var ref;
        (ref = recent.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", function() {});
        return function() {
            var ref;
            return (ref = recent.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", function() {});
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-6 lg:mt-[5.75rem] mx-4.5 lg:mx-8 xl:mx-16 flex flex-col-reverse lg:flex-row lg:space-x-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-3.5 lg:mt-0 lg:w-7/12 h-[31.25rem] lg:h-[32.625rem] focus:!outline-none focus-visible:!outline-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(map_MapRegion, {
                            mode: mode,
                            data: data.facilities
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:w-5/12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-neutral-900 font-bold text-title3 leading-[2.125rem] md:text-4xl md:leading-[3.5rem] lg:w-[33.438rem]",
                                children: [
                                    "Find Storage Unit Auctions Happening In ",
                                    data[type].name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-3 lg:mt-1.5 text-neutral-700 text-small-normal leading-6 md:text-large-normal md:leading-7 lg:w-[33.438rem]",
                                children: [
                                    "Subscribe to get access to storage unit auctions happening in across the state of ",
                                    data[type].name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-3 md:mt-7 font-bold text-neutral-900 text-large-normal md:text-title3",
                                children: "What you get when you signup..."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-3 text-small-normal leading-6 md:text-regular-normal text-neutral-900 pr-10",
                                children: "Instant Access to 100,000+ Monthly Storage Auctions"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-6 grid grid-cols-1 lg:grid-cols-2 gap-y-6 lg:gap-y-[2.125rem] lg:gap-x-6",
                                children: MenuList/* advgList.map */.k6.map(function(e, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center space-x-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "min-w-[2.75rem] md:min-w-[3.25rem] rounded-[0.875rem] p-2.5 md:p-3.5 w-fit ".concat(e.className),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(e.Icon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-bold lg:font-medium text-neutral-900 text-large-none lg:text-large-normal",
                                                children: e.title
                                            })
                                        ]
                                    }, key);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-6 lg:mt-[2.125rem] grid grid-cols-1 lg:grid-cols-2 gap-y-6 lg:gap-y-[2.125rem] lg:gap-x-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/facility/list?".concat(type === "city" ? "filter_state=".concat(data[type].state.id, "&state=").concat(data[type].state.name, "&filter_city=").concat(data[type].id, "&city=").concat(data[type].name) : "filter_state=".concat(data[type].id, "&state=").concat(data[type].name)),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    size: "lg",
                                                    className: "!rounded-full w-full !bg-primary-50 !text-primary-500 hover:!bg-primary-100 hover-anime",
                                                    children: "Browse Facilities"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "".concat("https://app.storageunitauctionlist.com", "/b/sign-up"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    size: "lg",
                                                    className: "!rounded-full w-full hover-anime",
                                                    children: "Sign Up"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            data.recent_adds.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-12 mx-4.5 lg:mx-8 xl:mx-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "font-bold text-neutral-900 text-title3 leading-[2.125rem] lg:text-4xl lg:leading-[3.5rem] md:block hidden",
                        children: [
                            "Last 10 Storage Unit Auctions Added in ",
                            data[type].name
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-bold text-neutral-900 text-title3 leading-[2.125rem] md:hidden",
                        children: "Last 10 Auctions Added"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-7 relative group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-y-3 right-0 opacity-0 group-hover:opacity-100 hover-anime cursor-pointer",
                                onClick: function() {
                                    return onScroll(200);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-white rounded-full p-3 shadow-lv3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* ArrowRight2Icon */.RE, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-y-3 left-0 opacity-0 group-hover:opacity-100 hover-anime cursor-pointer",
                                onClick: function() {
                                    return onScroll(-200);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-white rounded-full p-3 shadow-lv3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* ArrowRight2Icon */.RE, {
                                        className: "rotate-180"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: recent,
                                className: "overflow-x-auto sidebar flex flex-row items-center space-x-7 scroll-smooth",
                                children: data.recent_adds.map(function(e, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* CardAuctionDetail */.cO, {
                                        data: e
                                    }, key);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var partials_RegionDetail = (RegionDetail);


/***/ })

}]);